import {AddGlobalStyle} from "react-vextensions";
import {E} from "js-vextensions";
import React from "react";

// create a namespace JSX that is equivalent to import("react").JSX (for react 17->19 temp-fix/bridge)
/*import {JSX as JSX2} from "react";
declare global {
	namespace JSX {
		export import Element = JSX2.Element;
		export import ElementAttributesProperty = JSX2.ElementAttributesProperty;
		export import ElementChildrenAttribute = JSX2.ElementChildrenAttribute;
		export import ElementClass = JSX2.ElementClass;
		export import ElementType = JSX2.ElementClass;
		export import IntrinsicAttributes = JSX2.IntrinsicAttributes;
		export import IntrinsicClassAttributes = JSX2.IntrinsicClassAttributes;
		export import IntrinsicElements = JSX2.IntrinsicElements;
		export import LibraryManagedAttributes = JSX2.LibraryManagedAttributes;
	}
}*/

export const styles = {
	/*page: ES({
		//width: 960, margin: "100px auto",
		flex: "0 1 960px", //margin: "100px auto", maxHeight: "calc(100% - 200px)",
		//margin: "100px auto", padding: 50, background: "rgba(0,0,0,.75)", borderRadius: 10, cursor: "auto",
		//flex: 1,
	}),*/
	vMenuItem: {padding: "3px 5px", borderTop: "1px solid rgba(255,255,255,.1)"},

	pageContainer: {
		// presumably-temp fix for "display:flex" + "filter:..." causing page to not show up! (in recent chrome versions)
		willChange: "filter",
	},

	// fixes that height:100% doesn't work in safari, when in flex container
	fillParent_abs: {position: "absolute", left: 0, right: 0, top: 0, bottom: 0},

	darkenedBox_configPage: {backgroundColor: "rgba(0,0,0,.5)", borderRadius: 5, padding: 5},
};
export const colors = {
	//navBarBoxShadow: "rgba(100, 100, 100, .3) 0px 0px 3px, rgba(70,70,70,.5) 0px 0px 150px",
	// daytime-mode disables certain features, like alarms (affected options tinted with this light blue)
	nightTint: `rgba(200,200,255,.9)`,

	mapUI_background: "rgba(25,25,25,1)",
	mapUI_background_3j: "rgba(43,43,43,1)", // threejs has color-space handling or something, making its [43,43,43] look like css' [25,25,25]
	mapUI_panels: "rgba(30,30,30,1)",
};

AddGlobalStyle(`
.VMenu > div:first-child { border-top: initial !important; }
`);

/** Helper for dialog styling, maintaining some basic constraints:
 * For example, setting a max width and height. (which is especially important on mobile/small-screens) */
export function DialogStyle(opts: React.CSSProperties = {}, augmentOpts?: {maxWidthAdjust?: string|number, maxHeightAdjust?: string|number}): React.CSSProperties {
	const valToStr = (val: string|number)=>typeof val == "number" ? `${val}px` : val;
	const maxWidth_adjust_str = valToStr(augmentOpts?.maxWidthAdjust ?? "0px");
	const maxHeight_adjust_str = valToStr(augmentOpts?.maxHeightAdjust ?? "0px");
	return {
		/*maxWidth: opts.maxWidth ?? `calc(100% - 40px)`, // dialog-container has hard-coded 20[l] + 20[r] padding
		maxHeight: opts.maxHeight ?? `calc(100% - 32px - 20px - 30px)`, // 32: header, 20: dialog-container padding, 30: dialog buttons-row*/
		// use vw/vh units instead of %, because it works more reliably (%-based max-height was just being ignored fsr)
		// 40: hard-coded 20[l] + 20[r] padding of dialog-container
		maxWidth: opts.maxWidth ?? `calc(100vw - 40px + ${maxWidth_adjust_str})`,
		// 32: header, 20: dialog-container padding, 30: dialog buttons-row
		maxHeight: opts.maxHeight ?? `calc(100vh - 32px - 20px - 30px + ${maxHeight_adjust_str})`,
		//padding: opts.padding ?? "10px 0", // commented; dialog adds its own 10[t] + 10[b] padding
		...opts,
	};
}

/** Helper to extract padding amounts, in pixels, from either the "padding" field, or the padding left/top/right/bottom fields. */
export function ReadPaddingsFromCSS(opts: React.CSSProperties): {top: number, right: number, bottom: number, left: number} {
	const result = {top: 0, right: 0, bottom: 0, left: 0};

	if (typeof opts.padding == "number") Object.assign(result, {top: opts.padding, right: opts.padding, bottom: opts.padding, left: opts.padding});
	if (typeof opts.padding == "string") {
		const p = opts.padding.split(" ");
		const pFloat = p.length == 1 ? parseFloat(opts.padding) : null;
		if (p.length == 1) Object.assign(result, {top: pFloat, right: pFloat, bottom: pFloat, left: pFloat});
		if (p.length == 2) Object.assign(result, {top: parseFloat(p[0]), right: parseFloat(p[1]), bottom: parseFloat(p[0]), left: parseFloat(p[1])});
		if (p.length == 3) Object.assign(result, {top: parseFloat(p[0]), right: parseFloat(p[1]), bottom: parseFloat(p[2]), left: parseFloat(p[1])});
		if (p.length == 4) Object.assign(result, {top: parseFloat(p[0]), right: parseFloat(p[1]), bottom: parseFloat(p[2]), left: parseFloat(p[3])});
	}

	if (opts.paddingTop) result.top = parseFloat("" + opts.paddingTop);
	if (opts.paddingRight) result.right = parseFloat("" + opts.paddingRight);
	if (opts.paddingBottom) result.bottom = parseFloat("" + opts.paddingBottom);
	if (opts.paddingLeft) result.left = parseFloat("" + opts.paddingLeft);

	return result;
}

/** The <Slider> wrapper-comp has outdated types; use this to easily add the flex:1 style. */
export const sliderFlex = {style: {flex: 1}};